import React, { useRef, useState } from "react";
import classes from "./addCustomerElements.module.scss";

const AddCustomerRequest = ({ currentCurl, currentJson, currentFetch }) => {
  const curlRef = useRef();
  const [isCurlCopied, setIsCurlCopied] = useState(false);
  const [selectedTab, setSelectedTab] = useState("curl");

  const onCopyCurlHandler = () => {
    console.log(curlRef.current.textContent);
    navigator.clipboard.writeText(curlRef.current.textContent);

    setIsCurlCopied(true);
    setTimeout(() => {
      setIsCurlCopied(false);
    }, 1500);
  };

  const onChangeRequestHandler = (target) => setSelectedTab(target);

  return (
    <div>
      <div className={`${classes["btns-container"]} pe-3`}>
        <button
          onClick={() => onChangeRequestHandler("curl")}
          className={selectedTab === "curl" ? "fw-bold" : ""}
        >
          curl
        </button>
        <button
          onClick={() => onChangeRequestHandler("jsonrpc")}
          className={selectedTab === "jsonrpc" ? "fw-bold" : ""}
        >
          jsonrpc
        </button>
        <button
          onClick={() => onChangeRequestHandler("fetch")}
          className={selectedTab === "fetch" ? "fw-bold" : ""}
        >
          fetch
        </button>
      </div>
      <div className={`${classes["curl-container"]} p-3`}>
        <div className={classes["curl-content"]}>
          <p ref={curlRef} onClick={onCopyCurlHandler}>
            {selectedTab === "curl" && currentCurl}
            {selectedTab === "jsonrpc" && currentJson}
            {selectedTab === "fetch" && currentFetch}
          </p>
          {isCurlCopied && (
            <span className={classes["curl-copied"]}>Copied!</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCustomerRequest;
